import { render, staticRenderFns } from "./ImagingRequests.vue?vue&type=template&id=2cfbcf4a&"
import script from "./ImagingRequests.vue?vue&type=script&lang=js&"
export * from "./ImagingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports